@charset "UTF-8";

/* projects/speaker-platform/src/app/pages/statistic/statistic.component.scss */
.statslist__page {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 18px;
  padding: 20px;
  background-color: #fff;
  position: relative;
  min-height: 200px;
}
.statslist__header {
  position: sticky;
  z-index: 3;
  top: 0;
  background-color: white;
}
.statslist__table thead {
  position: sticky;
  z-index: 2;
}
.statslist__table thead tr th {
  position: sticky;
  top: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  font-size: 14px;
  font-weight: 700;
}
.containe-forTable {
  max-height: 610px;
  overflow-y: auto;
}
.containe-forTable table {
  display: block;
  width: 100%;
}
.containe-forTable thead,
.containe-forTable tbody {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.containe-forTable thead {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}
/*# sourceMappingURL=statistic.component-SZ433DA3.css.map */
